export const GET_COMPONENT_GROUPING_BY_SWATCH = "GET_COMPONENT_GROUPING_BY_SWATCH";
export const SET_COMPONENT_GROUPING_BY_SWATCH = "SET_COMPONENT_GROUPING_BY_SWATCH";

export const SET_COMPONENT_PARENT_CHILD_CONFIGURATION = "SET_COMPONENT_PARENT_CHILD_CONFIGURATION";